"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
function parse(coeffInterval) {
    const parseNum = (index) => parseFloat(coeffInterval[index][1]);
    return {
        aMin: parseNum(0),
        aMax: parseNum(1),
        aStep: parseNum(2),
        bMin: parseNum(3),
        bMax: parseNum(4),
        bStep: parseNum(5),
        cMin: parseNum(6),
        cMax: parseNum(7),
        cStep: parseNum(8),
        dMin: parseNum(9),
        dMax: parseNum(10),
        dStep: parseNum(11)
    };
}
//# sourceMappingURL=parse-coeff-interval.js.map